// extracted by mini-css-extract-plugin
module.exports = {"outer":"circleProgress_outer__O0sCw","spin":"circleProgress_spin__2qMCt","inner":"circleProgress_inner__14NIe"};